import { CURRENCY_SYMBOLS } from './Currency';
/**
 * Format number value to amount string with currency
 * @deprecated Use `Currency.fromNumber` instead
 */
export const toCurrency = (i18n, value, code, { format, precision = 2, stripInsignificantZeros } = {}) => i18n.toCurrency(value, {
    format,
    precision,
    unit: CURRENCY_SYMBOLS[code],
    strip_insignificant_zeros: stripInsignificantZeros,
});
